module.exports = "/dist/0d7e71f2b5cc1ddab837f72e1fe52f3f.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-700.woff2
// module id = 161
// module chunks = 0